module.exports = __webpack_public_path__ + "static/alta-57660a063c16c04a95a74dbf6f16ab3b.jpg";